// src/components/onboarding/onboardingNav.js
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.jsx";
import { getLandingRouteForUser } from "../../shared/_helpers/landingRoute";

// Where a `{ stage, routeFor }` answer sends the client: the stage's own web
// page, or — when the server says null (trial_start and later in SP3) — the
// legacy landing rule, read with the FRESH stage so a stale stored one can
// never send them back into onboarding.
export function landingFor({ stage, routeFor }, user) {
  if (routeFor?.web) return routeFor.web;
  return getLandingRouteForUser({
    ...(user || {}),
    userType: user?.userType || "client",
    onboardingStage: stage,
  });
}

// Review Focus #2: any SP3 route called off-stage answers
// 409 { code: 'wrong_stage', stage, routeFor }. That is navigation, never an
// error toast.
export const isWrongStage = (err) =>
  err?.response?.status === 409 && err?.response?.data?.code === "wrong_stage";

// Pooled inbox SP5 (R218): a client without chat access is refused with
// 402 { code: 'plan_required', stage, routeFor, entitlement } by the thread
// routes, booking and add-ons. Like wrong_stage it is navigation — go(payload)
// to `routeFor` — never an error message.
export const isPlanRequired = (err) =>
  err?.response?.status === 402 &&
  err?.response?.data?.code === "plan_required";

// `go(payload)` navigates to landingFor(payload) for the signed-in client.
export function useStageNavigation() {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (payload) => navigate(landingFor(payload, user));
}
